import { Stack, Table, Text } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { RecentTransferResponse } from '../../../data/hostDashboard.service'
import { COLORS } from '../../../utils/constants'
import { convertServerDateToLocal } from '../../../utils/dateUtils'
import { formatNumber } from '../../../utils/displayUtils'
import RecentPayoutCard from './RecentPayoutCard'

type RecentPayoutsTableProps = {
  transfers: RecentTransferResponse[]
}

const RecentPayoutsTable = ({ transfers }: RecentPayoutsTableProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)')

  if (isMobile) {
    return (
      <Stack gap='md'>
        {transfers.map((transfer) => (
          <RecentPayoutCard key={transfer.id} transfer={transfer} />
        ))}
      </Stack>
    )
  }

  return (
    <Table striped highlightOnHover withTableBorder>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Date</Table.Th>
          <Table.Th>Advertiser</Table.Th>
          <Table.Th>Location</Table.Th>
          <Table.Th>Device</Table.Th>
          <Table.Th>Ad Name</Table.Th>
          <Table.Th>Amount</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {transfers.map((transfer) => (
          <Table.Tr key={transfer.id}>
            <Table.Td>
              {convertServerDateToLocal(
                new Date(transfer.date),
              )?.toLocaleDateString()}
            </Table.Td>
            <Table.Td>{transfer.advertiserOrganizationName}</Table.Td>
            <Table.Td>{transfer.locationName}</Table.Td>
            <Table.Td>{transfer.deviceName}</Table.Td>
            <Table.Td>{transfer.adName}</Table.Td>
            <Table.Td>
              <Text fw={600} c={COLORS.LightGreen}>
                ${formatNumber(transfer.amount)}
              </Text>
            </Table.Td>
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  )
}

export default RecentPayoutsTable
